module.exports = __webpack_public_path__ + "img/speelmuur.a1abc8a6.jpg";